import { useState } from 'react'
import { BellRing, Megaphone } from 'lucide-react'
import UserReminderSettingsTab from './UserReminderSettingsTab'
import ChannelReminderSettingsTab from './ChannelReminderSettingsTab'

const SUB_TABS = [
  { id: 'reminder-settings', label: '用户弹窗设置', icon: BellRing },
  { id: 'channel-reminder-settings', label: '渠道弹窗设置', icon: Megaphone }
]

export default function UserReminderContainerTab() {
  const [activeSubTab, setActiveSubTab] = useState('reminder-settings')

  const renderContent = () => {
    switch (activeSubTab) {
      case 'channel-reminder-settings':
        return <ChannelReminderSettingsTab />
      case 'reminder-settings':
      default:
        return <UserReminderSettingsTab />
    }
  }

  return (
    <div className="space-y-6">
      <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800">
        <div className="flex flex-wrap gap-3">
          {SUB_TABS.map((tab) => {
            const Icon = tab.icon
            const isActive = activeSubTab === tab.id

            return (
              <button
                key={tab.id}
                onClick={() => setActiveSubTab(tab.id)}
                className={`inline-flex items-center gap-2 rounded-lg border px-4 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? 'border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-800 dark:bg-blue-900/30 dark:text-blue-400'
                    : 'border-gray-200 bg-gray-50 text-gray-600 hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-900/50 dark:text-gray-400 dark:hover:bg-gray-700'
                }`}
              >
                <Icon className="h-4 w-4" />
                {tab.label}
              </button>
            )
          })}
        </div>
      </div>

      {renderContent()}
    </div>
  )
}
